import React from "react";
import Footer from "../components/Footer/Footer";
import "./Page.css";

function About() {
  return (
    <div className="page-container">
      <div className="content-card">
        <h1 className="page-title">About The Sixteenth Degree (Private) Limited</h1>
        
        <div className="page-content">
          <p>
            The Sixteenth Degree (Private) Limited is a technology company based in Karachi, Pakistan, dedicated to building modern, human-centered digital products that solve real problems in emerging markets. Our name represents advancement through knowledge, discipline, and craftsmanship—reflecting our commitment to excellence in building software products, mobile applications, and providing technology consultancy.
          </p>

          <p>
            We are guided by innovation, precision, and integrity in everything we create. Our mission is to craft simple, thoughtful, and meaningful technology for millions of users, designed and developed with an unwavering focus on privacy, reliability, and user-first experiences.
          </p>

          <p>
            Our dedicated practitioners work across product strategy, software engineering, AI-powered systems, and user experience design to bring innovative ideas to life. Through a refined approach to continuous improvement and responsible innovation, we deliver high-quality digital services that meet the highest standards of excellence.
          </p>

          <div className="info-section">
            <h2>Our Approach</h2>
            <p>
              We approach every project with methodical precision and a commitment to excellence. Our work is guided by principles of innovation, precision, and integrity—values that inform every line of code, every design decision, and every strategic choice we make.
            </p>
            <p>
              Through disciplined practice and continuous refinement, we build software products that stand the test of time. We believe in the pursuit of mastery, where each advancement builds upon the foundation of knowledge and experience that came before.
            </p>
          </div>

          <div className="info-section">
            <h2>Registered Office</h2>
            <p>
              Dolmen Executive Tower, Suite 706, Level 7, Sea View Road, Clifton, Karachi, Pakistan
            </p>
          </div>

          <div className="info-section">
            <h2>Contact Email</h2>
            <p>
              <strong>General Inquiries</strong>{" "}
              <a href="mailto:baig@thesixteenthdegree.com">
                baig@thesixteenthdegree.com
              </a>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default About;

